import { Injectable } from '@angular/core';
import { Energieart } from '../../domain/model/energieart';

@Injectable({
    providedIn: 'root',
})
export class EnergieartNameService {

    public getNameForEnergieart(energieart: Energieart): string {
        switch (energieart) {
            case Energieart.WIND:
                return 'Windenergie';
            case Energieart.GASE_BIOMASSE:
                return 'Deponie-/Gruben-/Klärgas, Biomasse';
            case Energieart.WASSER:
                return 'Wasserkraft';
            case Energieart.SOLAR:
                return 'Solarenergie';
            case Energieart.BHKW:
                return 'BHKW-/IKWAnlagen';
            case Energieart.GEOTHERMIE:
                return 'Geothermie';
        }
        return 'Sonstige';
    }
}
